__turbopack_context__.v({
  "TeaserBlock": "YFM9mW_TeaserBlock",
  "TeaserBlock__Body": "YFM9mW_TeaserBlock__Body",
  "TeaserBlock__Container": "YFM9mW_TeaserBlock__Container",
  "TeaserBlock__Title": "YFM9mW_TeaserBlock__Title",
  "TeaserBlock__VideoContainer": "YFM9mW_TeaserBlock__VideoContainer",
});
